import React from 'react';
import { clsx } from 'clsx';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'brawn' | 'brains' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
}
export function Button({
  children,
  className,
  variant = 'primary',
  size = 'md',
  ...props
}: ButtonProps) {
  const baseStyles = 'font-bold uppercase tracking-wider transition-all duration-200 active:scale-95 disabled:opacity-50 disabled:pointer-events-none rounded-sm';
  const variants = {
    primary: 'bg-white text-black hover:bg-gray-200 border-2 border-white',
    brawn: 'bg-orange-600 text-white hover:bg-orange-700 border-2 border-orange-600 shadow-[0_0_15px_rgba(234,88,12,0.5)]',
    brains: 'bg-cyan-600 text-white hover:bg-cyan-700 border-2 border-cyan-600 shadow-[0_0_15px_rgba(8,145,178,0.5)] font-mono',
    outline: 'bg-transparent text-white border-2 border-white/20 hover:border-white/50 hover:bg-white/5'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-6 text-xl md:text-2xl'
  };
  return <button className={clsx(baseStyles, variants[variant], sizes[size], className)} {...props} data-id="element-237">
      {children}
    </button>;
}